var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-change-box"},_vm._l((_vm.items),function(item){return _c('div',{key:item.value,class:['btn-change-item', item.value === _vm.value ? 'btn-change-active':'btn-change-normal'],on:{"click":function($event){return _vm.$emit('input', item.value)}}},[_vm._v("\n    "+_vm._s(item.text)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0c50ba0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/YUI/BtnChangeGroup/index.vue
// module id = null
// module chunks = 